export enum Subcategory {
  interns = "INTERNS_TRAINEES",
  dinner = "DINNER",
  meals = "TRAVEL_MEALS",
  market = "TRAVEL_MARKET",
}
